/* shared Prestige-style components for Dawn */
if (!customElements.get('ap-carousel')) {
  customElements.define('ap-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ap-coll__track');
      this.prev = this.querySelector('.ap-coll__nav--prev');
      this.next = this.querySelector('.ap-coll__nav--next');
      if (!this.track || !this.prev || !this.next) return;
      const step = () => this.track.clientWidth;
      this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      this.next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      const update = () => {
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      };
      this.track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  });
}

if (!customElements.get('ap-grid-mode')) {
  customElements.define('ap-grid-mode', class extends HTMLElement {
    connectedCallback() {
      const grid = document.getElementById(this.dataset.grid);
      if (!grid) return;
      const key = 'ap-grid-' + this.dataset.device;
      const apply = (cols) => {
        grid.style.setProperty(this.dataset.device === 'mobile' ? '--ap-cols-m' : '--ap-cols-d', cols);
        this.querySelectorAll('button').forEach((b) => b.classList.toggle('is-active', b.dataset.cols === String(cols)));
      };
      let saved = null;
      try { saved = sessionStorage.getItem(key); } catch (e) {}
      if (saved) apply(saved);
      this.querySelectorAll('button').forEach((b) => b.addEventListener('click', () => {
        apply(b.dataset.cols);
        try { sessionStorage.setItem(key, b.dataset.cols); } catch (e) {}
      }));
    }
  });
}

/* Quick add (+) on product cards: add to cart via AJAX and open Dawn cart drawer */
if (!window.apQuickAddBound) {
  window.apQuickAddBound = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest && event.target.closest('.ap-qb-form');
    if (!form) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    event.preventDefault();
    const button = form.querySelector('button');
    if (button) { button.disabled = true; button.style.opacity = '.5'; }
    try {
      const body = new FormData(form);
      body.append('sections', 'cart-drawer,cart-icon-bubble');
      body.append('sections_url', window.location.pathname);
      const url = (window.routes && window.routes.cart_add_url) || '/cart/add';
      const res = await fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body });
      const data = await res.json();
      if (data.status) { alert(data.description || data.message || 'Could not add to cart'); return; }
      drawer.classList.remove('is-empty');
      drawer.renderContents(data);
    } catch (e) {
      form.submit();
    } finally {
      if (button) { button.disabled = false; button.style.opacity = ''; }
    }
  });
}
